import { render } from "./AccountPrizeInfoBlock.vue?vue&type=template&id=32df4e19"
import script from "./AccountPrizeInfoBlock.vue?vue&type=script&lang=js"
export * from "./AccountPrizeInfoBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__